export default __webpack_public_path__ + "static/media/muskmelon.fe81a047.png";